module.exports = __webpack_public_path__ + "portal-static/img/3.0268e746.jpg";